import React from 'react';

import Conditional from '../../common/conditional';
import usePassword from '../../../hooks/usePassword';

import * as models from '../../../utils/models';
import css from './input.module.scss';

const Input: React.FC<models.InputProps> = ({ type, ...otherProps }) => {
	const password = usePassword(type as React.HTMLInputTypeAttribute);

	const getFieldClassName = (): string => {
		let defaultClass: string = css['form-input-group-field'];
		if (otherProps.error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	};

	const getContainerClassName = (): string => {
		let defaultClass: string = css['form-input-group-container'];
		if (otherProps.error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	};

	return (
		<div className={css['form-input-group']}>
			{otherProps.label && <label htmlFor={otherProps.name}>{otherProps.label}:</label>}

			<div className={getContainerClassName()}>
				<input
					type={password.type}
					id={otherProps.name}
					name={otherProps.name}
					autoComplete='new-password'
					{...otherProps}
					className={getFieldClassName()}
				/>

				<Conditional isVisible={type === 'password'}>
					<button
						className={css['form-input-group-button']}
						type="button"
						onClick={password.togglePasswordView}
					>
						<i className={'bi bi-' + password.icon}></i>
					</button>
				</Conditional>
			</div>

			{otherProps.error && <div className="error">{otherProps.error}</div>}
		</div>
	);
};

export default Input;
